import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getProjectsUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/projects`;

const toggleProjectUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/projects/${pId}/toggle`;

const getProjectByIdUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/projects/${pId}`;

const updateProjectUrl = (pId, cId, sId) => `/companies/${cId}/subcompanies/${sId}/projects/${pId}`;

const addProjectUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/projects`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getProjectsUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(projectId, companyId, subcompanyId) {
    const url = toggleProjectUrl(projectId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(projectId, companyId, subcompanyId) {
    const url = getProjectByIdUrl(projectId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(projectId, companyId, subcompanyId, provider) {
    const url = updateProjectUrl(projectId, companyId, subcompanyId);
    return this.axios
      .put(url, provider, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, provider) {
    const url = addProjectUrl(companyId, subcompanyId);
    return this.axios
      .post(url, provider, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/projects.api.js